// extracted by mini-css-extract-plugin
module.exports = {"comp":"AU2_comp__68h0a"};